module.exports = __webpack_public_path__ + "static/media/tucson-liliana.9c578f8e.jpg";